const POShipmentPreBookingSearchType = {
  GET_SHIPMENT_PRE_BOOKING_INFO_LIST: 'GET_SHIPMENT_PRE_BOOKING_INFO_LIST',
  GET_SHIPMENT_PRE_BOOKING_INFO_LIST_SUCCESS: 'GET_SHIPMENT_PRE_BOOKING_INFO_LIST_SUCCESS',
  GET_SHIPMENT_PRE_BOOKING_INFO_LIST_FAIL: 'GET_SHIPMENT_PRE_BOOKING_INFO_LIST_FAIL',
  GET_SHIPMENT_PRE_BOOKING_INFO_LIST_RESET: 'GET_SHIPMENT_PRE_BOOKING_INFO_LIST_RESET',
  UPDATE_SHIPMENT_PRE_BOOKING_INFO_LIST_REQUEST: 'UPDATE_SHIPMENT_PRE_BOOKING_INFO_LIST_REQUEST',
  UPDATE_SHIPMENT_PRE_BOOKING_INFO_LIST_CHECKED_ITEMS: 'UPDATE_SHIPMENT_PRE_BOOKING_INFO_LIST_CHECKED_ITEMS',
  SET_SHIPMENT_PRE_BOOKING_SEARCH_EXPORT_TOGGLE: 'SET_SHIPMENT_PRE_BOOKING_SEARCH_EXPORT_TOGGLE',
};

export default POShipmentPreBookingSearchType;
